import { render, staticRenderFns } from "./product-made.vue?vue&type=template&id=5fdd55de&scoped=true"
import script from "./product-made.vue?vue&type=script&lang=js"
export * from "./product-made.vue?vue&type=script&lang=js"
import style0 from "./product-made.vue?vue&type=style&index=0&id=5fdd55de&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/product-made.less?vue&type=style&index=1&id=5fdd55de&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd55de",
  null
  
)

export default component.exports